import React, { useState, useEffect } from 'react';

function ErrorBoundary({ children }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    function handleError(error, info) {
      // setError(error);
    }

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  if (error) {
    return <FallbackComponent error={error} />;
  }

  return children;
}

function FallbackComponent({ error }) {
  return (
    <div>
      <h1>Something went wrong!</h1>
      <p>{error.message}</p>
    </div>
  );
}

export default ErrorBoundary;
